module.exports = __webpack_public_path__ + "static/media/employee.5e33da9b.png";